import { FC, HTMLAttributes } from "react";
import styled from "styled-components";
import LoaderImg from "assets/images/apng/loader.png";

const Container = styled.div`
  position: absolute;
  width: 200px;
  height: 25vh;
  left: calc((100% - 200px) / 2);
  top: calc((100% - 25vh) / 2);
  background: url(${LoaderImg}) center / contain no-repeat;
`;

export type LoadingProps = HTMLAttributes<HTMLDivElement> & {
  
};

export const Loading: FC<LoadingProps> = ({ ...props }) => {
  return (
    <Container />
  );
};
